import ApiService from '@/services/api.service';
import { PUBLIC_ROOT_API } from '@/config/app.config';
import { QuestionnaireDTO } from '@/models/QuestionnaireDTO';
import store from '@/store';

export default class QuestionnaireService {

  /**
   * Update Questionnaire
   * @param {QuestionnaireDTO} questionnaire The Questionnaire DTO object
   */
  public static async updateQuestionnaire(questionnaire: QuestionnaireDTO, part: string) {
    await ApiService.post(`${PUBLIC_ROOT_API}/equest/questionnaires/${part}`,
      questionnaire)
      // tslint:disable-next-line: no-empty
      .then((response: any) => { 
        store.commit('setQuestionnaireValidationErrors', {});
      });
  }

  /**
   * Consent
   * @param {string} partId The participant Id
   * @param {string} signature The signature
   * @param {QuestionnaireDTO} questionnaire The questionnaire
   * 
   * @returns {Date} The date when the accepted consent and signature
   */
  public static async consent(partId: number, signature: string, questionnaire: QuestionnaireDTO): Promise<Date> {
    const requestData = {
      url: `${PUBLIC_ROOT_API}/equest/questionnaires/${partId}/consent`,
      data: {
        value: signature,
        questionnaire: questionnaire,
      },
    };

    return await ApiService.post(requestData.url, requestData.data)
      .then((response: any) => {
        store.commit('setQuestionnaireValidationErrors', {});
        return response.data.consentDate as Date;
      });
  }

  /**
   * Confirm Questionnaire (and send it to the queue)
   * @param {string} partId The participant Id
   */
  public static async confirm(partId: number) {
    await ApiService.post(`${PUBLIC_ROOT_API}/equest/questionnaires/${partId}/confirm`, {})
      // tslint:disable-next-line: no-empty
      .then((response: any) => { });
  }



 /**
  * Fetch the questionnaire data
  * @param {string} partId The participant Id
  * @param {string|null} part The part of the questionnaire to fetch (optional).
  * Choice between: identity|insurance|address|doctor|questions.
  * If part is null, the whole quetionnaire will be fetched.
  * @returns {QuestionnaireDTO} A DTO object representing the participant
  */
  public static async fetchQuestionnaire(partId: number, part: string|null) {
    let endpoint = `${PUBLIC_ROOT_API}/equest/questionnaires/${partId}`;
    if (part != null) {
      endpoint = `${endpoint}/${part}`;
    }
    return await ApiService.get(endpoint)
      .then((response: any) => {
        return response.data as QuestionnaireDTO;
      });
  }
}
